import * as types from "./types";

export default {
  [types.GET_STATUS]:    state => state.status,
  [types.GET_STEPS]:     state => state.steps,
  [types.IS_COMPLETED]:  state => !!state.status.finished_at,
  [types.PROGRESS]:      state => {
    if (state.status.finished_at) return 100;
    return Math.floor(((state.status.current_step - 1) / state.steps.length) * 100);
  },
};